import styled from 'styled-components'
import { Button } from '~/shared/components/Button'
import { COLORS } from '~/shared/constants/uiConstants'

export const BiologyStyles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    overflow: hidden;

    &:before {
      position: absolute;
      z-index: -1;
      inset: 0;
      content: '';
      background: radial-gradient(
        ellipse at 22% 28%,
        #e8e899 0%,
        #aed48c 42%,
        #4aab68 100%
      );
    }
  `,

  MoleculaBig: styled.img`
    position: absolute;
    top: 36px;
    max-height: 200px;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
  `,

  MoleculaSmall: styled.img`
    position: absolute;
    top: 50px;
    max-height: 100px;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
  `,

  Content: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,

  StyledButton: styled(Button)`
    margin-bottom: 18px;
  `,

  Title: styled.h1`
    font-size: 26px;
    font-weight: 700;
    line-height: 32px;
    margin-bottom: 16px;
    text-align: center;
    color: ${COLORS.BLACK};

    span {
      color: ${COLORS.PURPLE_400};
      font-weight: 700;
    }
  `,

  Subtitle: styled.h2`
    position: relative;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: ${COLORS.BLACK_300};
  `,
}
